// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1SqUk","head":"Table_head__Wkwno","col":"Table_col__3AC92"};